import {
  Banknote, Briefcase, CalendarDays, ClipboardList, Fingerprint, HandCoins, Home, Layers,
  MessageSquare, PiggyBank, Plane, Receipt, Stethoscope, Timer, Wallet, type LucideIcon,
} from 'lucide-react'
import type { RequestCategory } from '@/api/requests'

/** Icon + tint per request type key (and the timed punch kinds). */
export const TYPE_META: Record<string, { icon: LucideIcon; tint: string }> = {
  attendance_correction: { icon: Fingerprint, tint: 'bg-purple-50 text-purple-600' },
  overtime: { icon: Timer, tint: 'bg-indigo-50 text-indigo-600' },
  leave: { icon: CalendarDays, tint: 'bg-blue-50 text-blue-600' },
  wfh: { icon: Home, tint: 'bg-teal-50 text-teal-600' },
  medical: { icon: Stethoscope, tint: 'bg-rose-50 text-rose-600' },
  expense: { icon: Receipt, tint: 'bg-amber-50 text-amber-600' },
  loan: { icon: HandCoins, tint: 'bg-emerald-50 text-emerald-600' },
  advance: { icon: Banknote, tint: 'bg-lime-50 text-lime-700' },
  pf: { icon: PiggyBank, tint: 'bg-pink-50 text-pink-600' },
  official_duty: { icon: Briefcase, tint: 'bg-slate-100 text-slate-600' },
  travel: { icon: Plane, tint: 'bg-sky-50 text-sky-600' },
  general: { icon: MessageSquare, tint: 'bg-gray-100 text-gray-600' },
  timed: { icon: ClipboardList, tint: 'bg-purple-50 text-purple-600' },
}

export const typeMeta = (key: string) => TYPE_META[key] || TYPE_META.general

export const CATEGORY_META: Record<'all' | RequestCategory, { label: string; icon: LucideIcon }> = {
  all: { label: 'All Requests', icon: Layers },
  attendance: { label: 'Attendance', icon: Fingerprint },
  leave: { label: 'Leave', icon: CalendarDays },
  finance: { label: 'Finance', icon: Wallet },
  other: { label: 'Other', icon: Briefcase },
}

export const STATUS_CLS: Record<string, string> = {
  pending: 'bg-amber-50 text-amber-700 border-amber-200',
  approved: 'bg-green-50 text-green-700 border-green-200',
  rejected: 'bg-red-50 text-red-700 border-red-200',
  cancelled: 'bg-gray-50 text-gray-600 border-gray-200',
  superseded: 'bg-gray-50 text-gray-500 border-gray-200',
}

export function money(n?: number | null) {
  return n == null ? '' : `PKR ${Number(n).toLocaleString(undefined, { maximumFractionDigits: 2 })}`
}
